import { OnboardingStep } from "components/pages/Onboarding/hooks/useSteps"
import { ICurrentUser } from "state/CurrentUserState"

export type GoogleEvents = {
  'onboarding_step': {
    name: OnboardingStep
  },
  'button_click': {
    name: string
    screen_name: string
  },
}

const safeGtag = (...args: Parameters<typeof window.gtag>) => {
  if (typeof window === 'undefined') return
  try { window.gtag?.(...args) } catch (e) { console.warn('[Analytics]', e) }
}

export const trackDashboardEvent = <K extends keyof GoogleEvents>(name: K, data: GoogleEvents[K]) => {
  safeGtag('event', name, data)
}
const setUserProperties = (properties: Record<string, any>) => {
  safeGtag('set', 'user_properties', properties)
}

const identifyUser = (userId: string) => {
  safeGtag('set', { user_id: userId })
}

export const Analytics = {
  trackEvent: trackDashboardEvent,
  initUser: (user: ICurrentUser) => {
    identifyUser(user._id)
    setUserProperties({
      country_code: user.countryCode,
      user_type: user.userType,
      nb_children: (user.children || []).length,
    })
  }
}
